import { fetchApi } from '@/config/axiosSetting.ts';
import { PostDamagedVehicleCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedVehicleCorrectiveImages/postDamagedVehicleCorrectiveImages.type';
import { AxiosResponse } from 'axios';

export const postInitialVisitCorrectiveImagesFunction = ({
  body,
  id,
}: PostDamagedVehicleCorrectiveImagesType): Promise<
  AxiosResponse<any, any>
> => {
  return fetchApi({
    method: 'post',
    url: `/initial/reports/${id}/images/corrective/send/request/`,
    data: body,
  });
};
